<script setup>
import {reactive, onMounted, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {FormValidation} from "@/Utils/FormValidation";
import {ToastUtil} from "@/Utils/ToastUtil";
const compName = 'InsuredInfoComponent';

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const form = ref(null);

const data = reactive({
  removeButton: false,
  copyingAddress: false,
  hoveredCellphone: false,
  hoveredHomephone: false,
  hoveredWorkphone: false,
  hoveredEmail: false,
  selected: [],
  phoneMessage: false,
  phoneMessageDetails: '',
  emailMessage: false,
  emailMessageDetails: '',
  dialog: false,
  editSelected: false,
  editSingle: false,
  contactSelected: false,
  contacttype: [
    'Attorney',
    'Claimant',
    'Contractor',
    'Insured Person',
    'Public Adjuster',
  ],
  loading: false,
  openForm: false,
  valid: true,
  newItem: {
    contacttype: '',
    name: '',
    streetaddress: '',
    city: '',
    state: '',
    zip: '',
    homephone: '',
    workphone: '',
    cellphone: '',
    email: '',
    longitude: '',
    latitude: '',
  },
  editedItem: {
    contacttype: '',
    name: '',
    streetaddress: '',
    city: '',
    state: '',
    zip: '',
    homephone: '',
    workphone: '',
    cellphone: '',
    email: '',
    longitude: '',
    latitude: '',
  },
  resetContactItem: {
    contacttype: '',
    name: '',
    streetaddress: '',
    city: '',
    state: '',
    zip: '',
    homephone: '',
    workphone: '',
    cellphone: '',
    email: '',
    longitude: '',
    latitude: '',
  },
  items: [],
  states: [
    'AL',
    'AK',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'MP',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ],
});

const acceptCellNumber = () => {
  let x = data.newItem.cellphone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  data.newItem.cellphone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

const acceptHomeNumber = () => {
  let x = data.newItem.homephone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  data.newItem.homephone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

const acceptWorkNumber = () => {
  let x = data.newItem.workphone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  data.newItem.workphone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

const copyAddress = () => {
  data.removeButton = true
  data.copyingAddress = true
  data.loading = true
  ApiWrapper.post('claim-info', 'claim-info',{}, 'claimId=' + props.contextIdA)
      .then((response) => {
        data.newItem.streetaddress = response.data.streetaddress;
        data.newItem.state = response.data.state;
        data.newItem.city = response.data.city;
        data.newItem.zip = response.data.zip;
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false
      })
}

const removePerson = (pid, rid) => {
  data.loading = true
  ApiWrapper.post('claims', 'remove-insured-contact', {
        pid: pid,
        rid: rid,
        claimId: props.contextIdA
      })
      .then((response) => {
        getData()
        data.contactSelected = false
        activeComponentStore.notifyComponents(['claimcontacts','adjusters'],compName);

        ToastUtil.successMsg('Removed insured contact');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

const editSelectedItem = () => {
  data.openForm = true
  data.editSelected = true
  data.editedItem = Object.assign({}, data.selected[0])
  data.newItem = Object.assign({}, data.selected[0])
}

const setSingleEdit = () => {
  data.openForm = true
  data.editSingle = true
  data.editedItem = Object.assign({}, data.items[0])
  data.newItem = Object.assign({}, data.items[0])
}

const formatPhoneNumber = (phoneNumberString) => {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }
  return null
}

const cancel = () => {
  if (data.editSingle) {
    data.items[0] = Object.assign({}, data.editedItem)
    data.editedItem = JSON.parse(JSON.stringify(data.resetContactItem))
  }
  if (data.editSelected) {
    data.selected[0] = Object.assign({}, data.editedItem)
    data.editedItem = JSON.parse(JSON.stringify(data.resetContactItem))
  }
  data.openForm = false
  data.removeButton = false
  data.copyingAddress = false
}

const selectContact = (item) => {
  data.selected = []
  data.selected.push(JSON.parse(JSON.stringify(item)))
  data.editedItem = JSON.parse(JSON.stringify(item))
}

const saveMessage = (type, personid) => {
  data.loading = true
  if (type === 'phone') {
    ApiWrapper.post('relationship-management', 'create-interaction', {
      claimId: props.contextIdA,
      interaction: data.phoneMessageDetails,
      contactId: personid,
      type: 'personinsured',
    })
        .then((response) => {
          activeComponentStore.notifyComponents(['messages'],compName);
          data.phoneMessage = false
          data.phoneMessageDetails = ''
          getData()

          ToastUtil.successMsg('Created note');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.loading = false;
        })
  } else if (type === 'email') {
    ApiWrapper.post('relationship-management', 'create-interaction', {
      claimId: props.contextIdA,
      interaction: data.emailMessageDetails,
      contactId: personid,
      type: 'personinsured',
    })
        .then((response) => {
          activeComponentStore.notifyComponents(['messages'],compName);
          data.emailMessage = false
          data.emailMessageDetails = ''
          getData()

          ToastUtil.successMsg('Created note');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.loading = false;
        })
  }
}

const getData = () => {
  data.loading = true

  ApiWrapper.post('claims', 'get-insured', { claimId: props.contextIdA })
      .then((response) => {
        data.items = response.insured;
        data.copyingAddress = false
        data.removeButton = false
        data.loading = false
        data.dialog = false
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

const back = () => {
  data.selected.splice(0, 1)
  data.contactSelected = false
}

const create = () => {
  if (form.value.validate()) {
    if (data.editSingle || data.editSelected) {
      data.loading = true
      if(data.newItem.streetaddress !== '' && data.newItem.streetaddress !== null){
        let encodedSearch = encodeURI(
            data.newItem.streetaddress.replace('#', '') +
            `, ` +
            data.newItem.city +
            `, ` +
            data.newItem.state +
            ` ` +
            data.newItem.zip
        )
        ApiWrapper.getRaw(
            'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
            encodedSearch +
            '.json?access_token=pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'
        )
            .then(function (response) {
              if(response.features){
                if (response.features.length === 0) {
                  getData()
                } else {
                  data.newItem.longitude =
                      response.features[0].center[0].toString()
                  data.newItem.latitude =
                      response.features[0].center[1].toString()
                  ApiWrapper.post('claims', 'update-insured', {
                    newItem: data.newItem,
                  })
                      .then((response) => {
                        activeComponentStore.notifyComponents(['claimcontacts'],compName);
                        getData()
                        back()

                        ToastUtil.successMsg('Updated insured information');
                      })
                      .catch((e)=>{
                        ToastUtil.error(e);
                      })
                      .finally(()=>{
                        data.loading = false;
                      });
                }
              }
            })
            .catch((err) => {
              ToastUtil.error(err);
              data.loading = false;
            });
      } else {
        ApiWrapper.post('claims', 'update-insured', {
              newItem: data.newItem,
            })
            .then((response) => {
              activeComponentStore.notifyComponents(['claimcontacts'],compName);
              getData()
              back()

              ToastUtil.successMsg('Updated insured information');
            })
            .catch((err) => {
              ToastUtil.error(err);
              data.loading = false;
            })
      }
      data.openForm = false
      data.editSingle = false
      data.editSelected = false
    }
    else {
      data.loading = true

      // if(data.newItem.streetaddress !== '' && data.newItem.streetaddress !== null){
      let encodedSearch = encodeURI(
          data.newItem.streetaddress.replace('#', '') +
          `, ` +
          data.newItem.city +
          `, ` +
          data.newItem.state +
          ` ` +
          data.newItem.zip
      )
      if(data.newItem.streetaddress !== ''){
        ApiWrapper.getRaw(
            'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
            encodedSearch +
            '.json?access_token=pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'
        )
        .then(function (response) {
          if(response.features) {
            if (response.features.length === 0) {
              // getClientContactData()
            } else {
              data.newItem.longitude =
                  response.features[0].center[0].toString()
              data.newItem.latitude =
                  response.features[0].center[1].toString()
              ApiWrapper.post('claims', 'create-insured', {
                    newItem: data.newItem,
                    claimId: props.contextIdA,
                  })
                  .then((response) => {
                    activeComponentStore.notifyComponents(['claimcontacts'],compName);
                    data.newItem = data.resetContactItem
                    data.openForm = false
                    getData()
                    back()
                    ToastUtil.successMsg('Created insured person');
                  })
                  .catch((err) => {
                    ToastUtil.error(err);
                    data.loading = false;
                  })
            }
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
          data.loading = false;
        })
      } else {
        ApiWrapper.post('claims', 'create-insured', {
              newItem: data.newItem,
              claimId: props.contextIdA,
            })
            .then((response) => {
              activeComponentStore.notifyComponents([''],compName);
              data.newItem = data.resetContactItem
              data.openForm = false
              getData()
              back()

              ToastUtil.successMsg('Created insured person');
            })
            .catch((e)=>{
              ToastUtil.error(e);
              data.loading = false;
            })
      }
    }
  }
}

onMounted(()=>{
  data.contacttype = data.contacttype.sort()
  getData()
});

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar density="compact" flat color="white">
        <v-toolbar-title>
          Claim
          <br>
          Contacts
        </v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>

        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn
            size="small"
            dark
            variant="elevated"
            color="primary"
            @click="data.openForm = true; data.newItem = Object.assign({}, data.resetContactItem)"
            v-if="!data.openForm && Permissions.checkPermissions(['claims.create-insured'])"
        >New
          <br />
          Contact
        </v-btn>
      </v-toolbar>

      <!-- Contact Info -->
      <v-form v-if="data.openForm" ref="form" v-model="data.valid" lazy-validation>
        <v-autocomplete
            class="px-5"
            v-model="data.newItem.contacttype"
            :items="data.contacttype"
            label="Enter or Select Type of Contact"
            clearable
            required
        >
        </v-autocomplete>
        <v-card-subtitle class="pt-0" v-if="data.newItem.contacttype"
        >{{data.newItem.contacttype}}</v-card-subtitle
        >
        <v-text-field
            v-model="data.newItem.name"
            label="Name"
            class="px-5"
            :rules="[v => !!v || 'Name is required']"
            required
            density="compact"
        ></v-text-field>
        <v-btn size="x-small" variant="elevated" v-if="!data.removeButton && Permissions.checkPermissions(['claims.read'])" class="success ml-4 my-4" @click="copyAddress()">
          Copy Loss Address
        </v-btn>
        <v-text-field
            v-model="data.newItem.streetaddress"
            label="Street Address"
            class="px-5"
            required
            density="compact"
        ></v-text-field>
        <v-text-field
            v-model="data.newItem.city"
            label="City"
            class="px-5"
            required
            density="compact"
        > </v-text-field>
        <v-autocomplete
            v-if="!data.copyingAddress"
            v-model="data.newItem.state"
            :items="data.states"
            label="State"
            class="px-5"
            auto-select-first
            density="compact"

        ></v-autocomplete>
        <v-text-field
            v-if="data.copyingAddress === true"
            v-model="data.newItem.state"
            label="State"
            class="px-5"
            required
            density="compact"
        > </v-text-field>
        <v-text-field
            v-model="data.newItem.zip"
            label="Zip"
            class="px-5"
            required
            density="compact"
        ></v-text-field>
        <v-text-field
            v-model="data.newItem.cellphone"
            label="Cell Phone"
            @input="acceptCellNumber"
            :rules="[FormValidation.phoneRules]"
            class="px-5"
            required
            density="compact"
        ></v-text-field>
        <v-text-field
            v-model="data.newItem.workphone"
            label="Work Phone"
            @input="acceptWorkNumber"
            :rules="[FormValidation.phoneRules]"
            class="px-5"
            required
            density="compact"
        ></v-text-field>
        <v-text-field
            v-model="data.newItem.homephone"
            label="Home Phone"
            @input="acceptHomeNumber"
            :rules="[FormValidation.phoneRules]"
            class="px-5"
            required
            density="compact"
        ></v-text-field>
        <v-text-field
            v-model="data.newItem.email"
            label="Email"
            class="px-5"
            required
            density="compact"
        >
        </v-text-field>
        <v-card-actions>
          <v-btn
              size="small"
              variant="elevated"
              v-if="data.openForm"
              color="red"
              class="white--text mr-2"
              @click="cancel(); "
          >Cancel</v-btn
          >
          <v-btn
              size="small"
              variant="elevated"
              color="primary"
              class="white--text"
              @click="create(); data.openForm = false"
              :disabled="!data.valid"
          >Submit
          </v-btn>
        </v-card-actions>
      </v-form>

      <!-- List of contacts if there are more than 1 contact -->
      <v-list density="compact" color="primary" class="py-0" v-if="typeof data.items === 'object' && data.items.length > 1 && !data.openForm && !data.contactSelected">
        <v-list-item
            density="compact"
            two-line
            v-for="(item) in data.items"
            :key="item.index"
            @click="selectContact(item); data.contactSelected = true"
        >
          <v-list-item-subtitle>{{item.contacttype}}</v-list-item-subtitle>
          <h2 v-if="item.contacttype === 'Insured Person'" class="font-weight-bold">{{item.name}}</h2>
          <v-list-item-title v-else>{{item.name}}</v-list-item-title>
        </v-list-item>
      </v-list>

      <!-- Contact info if there is only 1 contact -->
      <div v-if="typeof data.items === 'object' && data.items.length === 1 && !data.openForm && !data.contactSelected">
        <v-list density="compact" two-line v-for="(item, index) in data.items" :key="index">
          <v-card-subtitle class="py-0 font-weight-bold">{{item.contacttype}}</v-card-subtitle>
          <div class="pl-4 py-1">
            <v-list-item-subtitle>Name</v-list-item-subtitle>
            <h2 v-if="item.contacttype === 'Insured Person'" class="font-weight-bold">{{item.name}}</h2>
            <v-list-item-title v-else>{{item.name}}</v-list-item-title>
          </div>
          <div v-if="item.streetaddress !== null && item.streetaddress !== ''" class="pl-4 py-1">
            <v-list-item-subtitle>Address</v-list-item-subtitle>
            <v-list-item-title
            >{{item.streetaddress}}
              <br />
              {{item.city}} {{item.state}} {{item.zip}}
            </v-list-item-title>
          </div>
          <div
              v-if="item.cellphone !== null && item.cellphone !== ''"
              :class="{'cellphone-hover': data.hoveredCellphone}"
              class="pl-4 py-1"
              style="cursor:pointer"
              @mouseover="data.hoveredCellphone = true"
              @mouseleave="data.hoveredCellphone = false"
              @click="Permissions.checkPermissions(['relationship-management.create']) ? data.phoneMessage = true : true"
          >
            <v-list-item-subtitle>Cell Phone</v-list-item-subtitle>
            <v-list-item-title>{{formatPhoneNumber(item.cellphone)}}</v-list-item-title>
          </div>
          <div
              v-if="item.workphone !== null && item.workphone !== ''"
              :class="{'workphone-hover': data.hoveredWorkphone}"
              class="pl-4 py-1"
              style="cursor:pointer"
              @mouseover="data.hoveredWorkphone = true"
              @mouseleave="data.hoveredWorkphone = false"
              @click="Permissions.checkPermissions(['relationship-management.create']) ? data.phoneMessage = true : true"
          >
            <v-list-item-subtitle>Work Phone</v-list-item-subtitle>
            <v-list-item-title>{{formatPhoneNumber(item.workphone)}}</v-list-item-title>
          </div>
          <div
              v-if="item.homephone !== null && item.homephone!== ''"
              :class="{'homephone-hover': data.hoveredHomephone}"
              class="pl-4 py-1"
              style="cursor:pointer"
              @mouseover="data.hoveredHomephone = true"
              @mouseleave="data.hoveredHomephone = false"
              @click="Permissions.checkPermissions(['relationship-management.create']) ? data.phoneMessage = true : true"
          >
            <v-list-item-subtitle>Home Phone</v-list-item-subtitle>
            <v-list-item-title>{{formatPhoneNumber(item.homephone)}}</v-list-item-title>
          </div>
          <div style="margin: 10px" v-if="data.phoneMessage === true">
            <v-textarea
                filled
                v-model="data.phoneMessageDetails"
                auto-grow
                rows="2"
                label="Phone Message Details"
                density="compact"
            >
            </v-textarea>
            <v-card-actions>
              <v-btn
                  @click="saveMessage('phone', item.personinsuredid)"
                  color="primary"
                  v-if="data.phoneMessageDetails !== ''"
                  size="small"
                  variant="elevated"
              >Save</v-btn
              >
              <v-btn
                  size="small"
                  variant="elevated"
                  color="error"
                  @click="data.phoneMessage = false; data.phoneMessageDetails = ''"
              >Cancel</v-btn
              >
            </v-card-actions>

            <v-divider></v-divider>
          </div>
          <div
              v-if="item.email !== null && item.email !== ''"
              :class="{'email-hover': data.hoveredEmail}"
              class="pl-4 py-1"
              style="cursor:pointer"
              @mouseover="data.hoveredEmail = true"
              @mouseleave="data.hoveredEmail = false"
              @click="Permissions.checkPermissions(['relationship-management.create']) ? data.emailMessage = true : true"
          >
            <v-list-item-subtitle>Email</v-list-item-subtitle>
            <v-list-item-title>{{item.email}}</v-list-item-title>
          </div>
          <div style="margin: 10px" v-if="data.emailMessage === true">
            <v-textarea
                filled
                v-model="data.emailMessageDetails"
                auto-grow
                rows="2"
                label="Email Message Details"
                density="compact"
            >
            </v-textarea>
            <v-card-actions>
              <v-btn
                  @click="saveMessage('email', item.personinsuredid)"
                  color="primary"
                  v-if="data.emailMessageDetails !== ''"
                  size="small"
                  variant="elevated"
              >Save</v-btn
              >
              <v-btn
                  size="small"
                  variant="elevated"
                  color="error"
                  @click="data.emailMessage = false; data.emailMessageDetails = ''"
              >Cancel</v-btn
              >
            </v-card-actions>
            <v-divider></v-divider>
          </div>
        </v-list>
        <v-card-actions v-if="!data.openForm && data.loading === false">
          <v-btn
              size="small"
              variant="elevated"
              v-if="data.items.length > 0 && Permissions.checkPermissions(['claims.update-insured'])"
              dark
              class="mr-2"
              color="primary"
              @click="setSingleEdit()"
          >Edit
          </v-btn>
          <v-dialog
              v-model="data.dialog"
              persistent
              max-width="290">
            <template v-slot:activator="{ on, props }">
              <v-btn
                  size="small"
                  variant="elevated"
                  color="error"
                  class="ml-0"
                  dark
                  v-bind="props"
                  v-on="on"
                  v-if="Permissions.checkPermissions(['claims.remove-insured'])"
              >
                Remove
                <br>
                Contact
              </v-btn>
            </template>
            <v-card>
              <v-card-text class="pt-2">Are you sure you would like to remove the selected contact?</v-card-text>
              <v-card-actions>
                <v-btn
                    size="small"
                    color="error"
                    variant="text"
                    @click="data.dialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    size="small"
                    color="green darken-1"
                    variant="text"
                    @click="removePerson(data.items[0].id)"
                >
                  Confirm
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-actions>
      </div>

      <!-- Selected Contact -->
      <div v-if="typeof data.selected === 'object' && data.selected.length === 1 && !data.openForm && data.contactSelected === true">
        <v-list density="compact" two-line v-for="(item, index) in data.selected" :key="index">
          <v-card-subtitle class="py-0 font-weight-bold">{{item.contacttype}}</v-card-subtitle>
          <div class="pl-4 py-1">
            <v-list-item-subtitle>Name</v-list-item-subtitle>
            <v-list-item-title>{{item.name}}</v-list-item-title>
          </div>
          <div v-if="item.streetaddress !== null && item.streetaddress !== ''" class="pl-4 py-1">
            <v-list-item-subtitle>Address</v-list-item-subtitle>
            <v-list-item-title
            >{{item.streetaddress}}
              <br />
              {{item.city}} {{item.state}} {{item.zip}}
            </v-list-item-title>
          </div>
          <div
              v-if="item.cellphone !== null && item.cellphone !== ''"
              :class="{'cellphone-hover': data.hoveredCellphone}"
              class="pl-4 py-1"
              style="cursor:pointer"
              @mouseover="data.hoveredCellphone = true"
              @mouseleave="data.hoveredCellphone = false"
              @click="Permissions.checkPermissions(['relationship-management.create']) ? data.phoneMessage = true : true"
          >
            <v-list-item-subtitle>Cell Phone</v-list-item-subtitle>
            <v-list-item-title>{{formatPhoneNumber(item.cellphone)}}</v-list-item-title>
          </div>
          <div
              v-if="item.workphone !== null && item.workphone !== ''"
              :class="{'workphone-hover': data.hoveredWorkphone}"
              class="pl-4 py-1"
              style="cursor:pointer"
              @mouseover="data.hoveredWorkphone = true"
              @mouseleave="data.hoveredWorkphone = false"
              @click="Permissions.checkPermissions(['relationship-management.create']) ? data.phoneMessage = true : true"
          >
            <v-list-item-subtitle>Work Phone</v-list-item-subtitle>
            <v-list-item-title>{{formatPhoneNumber(item.workphone)}}</v-list-item-title>
          </div>
          <div
              v-if="item.homephone !== null && item.homephone !== ''"
              :class="{'homephone-hover': data.hoveredHomephone}"
              class="pl-4 py-1"
              style="cursor:pointer"
              @mouseover="data.hoveredHomephone = true"
              @mouseleave="data.hoveredHomephone = false"
              @click="Permissions.checkPermissions(['relationship-management.create']) ? data.phoneMessage = true : true"
          >
            <v-list-item-subtitle>Home Phone</v-list-item-subtitle>
            <v-list-item-title>{{formatPhoneNumber(item.homephone)}}</v-list-item-title>
          </div>
          <div style="margin: 10px" v-if="data.phoneMessage === true">
            <v-textarea
                filled
                v-model="data.phoneMessageDetails"
                auto-grow
                rows="2"
                label="Phone Message Details"
                density="compact"
            >
            </v-textarea>
            <v-card-actions>
              <v-btn
                  @click="saveMessage('phone', item.personinsuredid)"
                  color="primary"
                  v-if="data.phoneMessageDetails !== ''"
                  size="small"
                  variant="elevated"
              >Save</v-btn
              >
              <v-btn
                  size="small"
                  variant="elevated"
                  color="error"
                  @click="data.phoneMessage = false; data.phoneMessageDetails = ''"
              >Cancel</v-btn
              >
            </v-card-actions>
            <v-divider></v-divider>
          </div>
          <div
              v-if="item.email !== null && item.email !== ''"
              :class="{'email-hover': data.hoveredEmail}"
              class="pl-4 py-1"
              style="cursor:pointer"
              @mouseover="data.hoveredEmail = true"
              @mouseleave="data.hoveredEmail = false"
              @click="Permissions.checkPermissions(['relationship-management.create']) ? data.emailMessage = true : true"
          >
            <v-list-item-subtitle>Email</v-list-item-subtitle>
            <v-list-item-title>{{item.email}}</v-list-item-title>
          </div>
          <div style="margin: 10px" v-if="data.emailMessage === true">
            <v-textarea
                filled
                v-model="data.emailMessageDetails"
                auto-grow
                rows="2"
                label="Email Message Details"
                density="compact"
            >
            </v-textarea>
            <v-card-actions>
              <v-btn
                  @click="saveMessage('email', item.personinsuredid)"
                  color="primary"
                  v-if="data.emailMessageDetails !== ''"
                  size="small"
                  variant="elevated"
              >Save</v-btn
              >
              <v-btn
                  size="small"
                  variant="elevated"
                  color="error"
                  @click="data.emailMessage = false; data.emailMessageDetails = ''"
              >Cancel</v-btn
              >
            </v-card-actions>

            <v-divider></v-divider>
          </div>
        </v-list>
        <v-card-actions v-if="!data.openForm && data.loading === false">
          <v-btn size="small" variant="text" class="primary--text mr-1" @click="back">
            <v-icon>mdi-arrow-left</v-icon>
            Back
          </v-btn>
          <v-btn
              size="small"
              variant="elevated"
              v-if="data.items.length > 0 && Permissions.checkPermissions(['claims.update-insured'])"
              dark
              class="mr-2"
              color="primary"
              @click="editSelectedItem()"
          >Edit
          </v-btn>
          <v-dialog
              v-model="data.dialog"
              persistent
              max-width="290">
            <template v-slot:activator="{ on, props }">
              <v-btn
                  size="small"
                  variant="elevated"
                  color="error"
                  class="ml-0"
                  dark
                  v-bind="props"
                  v-on="on"
                  v-if="Permissions.checkPermissions(['claims.remove-insured'])"
              >
                Remove
                <br>
                Contact
              </v-btn>
            </template>
            <v-card>
              <v-card-text class="pt-2">Are you sure you would like to remove the selected contact?</v-card-text>
              <v-card-actions>
                <v-btn
                    size="small"
                    color="error"
                    variant="text"
                    @click="data.dialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    size="small"
                    color="green darken-1"
                    variant="text"
                    @click="removePerson(data.selected[0].id)"
                >
                  Confirm
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-actions>
      </div>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
/* .v-input .v-label {
  font-size: 13px !important;
} */

.v-card-subtitle {
  color: black !important;
}

.v-list-item-title {
  font-size: 13px !important;
  color: black !important;
}
.v-list-item-subtitle {
  font-size: 10px !important;
  color: black !important;
}
.v-list-item {
  min-height: 40px !important;
}
.v-list--dense .v-list-item .v-list-item__content, .v-list-item--dense .v-list-item__content {
  padding: 0 !important;
}
.cellphone-hover {
  background-color: #E3F2FD;
}
.homephone-hover {
  background-color: #E3F2FD;
}
.workphone-hover {
  background-color: #E3F2FD;
}
.email-hover {
  background-color: #E3F2FD;
}
</style>